import { object, number, boolean } from '@gogame/schemas';

import {
  APP_ID,
  BUSINESS_PARTNER,
  POSTBACK_AND_CONVERSIONS_STATUSES,
} from '../constants';

export const downloadTemplateSchema = object({
  [APP_ID]: number().required('Application is required'),
  [POSTBACK_AND_CONVERSIONS_STATUSES]: boolean(),
}).shape({
  [BUSINESS_PARTNER]: number().when(POSTBACK_AND_CONVERSIONS_STATUSES, {
    is: (field) => !!field,
    then: number().required('Business Partner is required'),
  }),
});
